/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../bitty/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cls": {
        "nested": {
          "fields": {
            "nested": {
              "bitcoin": {
                "nested": {
                  "BitcoinPaymentsStatusResult": {
                    "fields": {
                      "status": {
                        "type": ".squareup.bitty.BitcoinPaymentsStatus",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cls?.nested?.fields?.nested?.bitcoin?.nested?.BitcoinPaymentsStatusResult) {
  $root.addJSON(jsonData);
}

/**
 * Result wrapper for Bitcoin payments status.
 * Returns the BitcoinPaymentsStatus enum from the Bitty service.
 *
 * SOURCE BitcoinPaymentsStatusResult @ squareup/cls/fields/bitcoin/bitcoin_payments_status.proto at 14:1
 */
export const BitcoinPaymentsStatusResult = $root.lookupType('squareup.cls.fields.bitcoin.BitcoinPaymentsStatusResult');
fixType(BitcoinPaymentsStatusResult);
Builder.createAndAttachToType(BitcoinPaymentsStatusResult);